var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"grid-table__cell text-body-1 text-secondary-5 q-px-sm",class:{ 'full-row': _vm.fullRow }},[_vm._t("default"),(!_vm.noTooltip)?_c('LmTooltip',{attrs:{"delay":1000}},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }